export default __webpack_public_path__ + "static/media/MCM_logo_HQ.d581f034.png";